import { render, staticRenderFns } from "./DescriptionProductCard.vue?vue&type=template&id=108a2f4a&scoped=true&"
import script from "./DescriptionProductCard.vue?vue&type=script&lang=js&"
export * from "./DescriptionProductCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108a2f4a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CmsPage: require('/var/www/linza-front/linza-front-20251024095940/cms/CmsPage.vue').default})
